import moment from 'moment-timezone';

export class DateTimeUtilities {
    /**
     * Converts input date and time fields to a UTC datetime string
     * @param inputDate - The date string
     * @param inputHours - The hours string
     * @param inputMinutes - The minutes string
     * @param inputMeridiem - AM/PM indicator
     * @param inputSeconds - The seconds string (defaults to '0')
     * @param timeZoneInfoName - The timezone name
     * @param dateFormat - The date format to use for parsing
     * @returns UTC datetime string
     */
    static getUtcDateTimeStringFromInputFields(
        inputDate: string,
        inputHours: string,
        inputMinutes: string,
        inputMeridiem: string,
        timeZoneInfoName: string,
        dateFormat: string,
        inputSeconds: string = '0'
    ): string {
        // Due to a quirk with moment.tz that can shift the date of a time when changing the time zone,
        // we'll parse the input date up front in one moment, and then apply that to another moment
        // after we manually set the time zone.
        let parsedDateMoment = moment(inputDate, dateFormat.toUpperCase());
        if (!parsedDateMoment.isValid()) {
            parsedDateMoment = moment(inputDate);
        }

        let hoursAdjusted = parseInt(inputHours, 10);
        if (inputMeridiem === 'PM' && hoursAdjusted < 12) {
            hoursAdjusted += 12;
        } else if (inputMeridiem === 'AM' && hoursAdjusted === 12) {
            hoursAdjusted -= 12;
        }

        return moment()
            .tz(timeZoneInfoName)
            .set({
                year: parsedDateMoment.year(),
                month: parsedDateMoment.month(),
                date: parsedDateMoment.date(),
                hours: hoursAdjusted,
                minutes: parseInt(inputMinutes, 10),
                seconds: parseInt(inputSeconds, 10)
            })
            .utc()
            .format();
    }
}
